module.exports = __webpack_public_path__ + "img/PW.149d7812.svg";